export default __webpack_public_path__ + "static/media/BRB.69090268.svg";